export default __webpack_public_path__ + "assets/img_webp/ko-logo.d693dd1d.png";